export const SvgConstants = Object.freeze({
    MIN_FONT_SIZE: 30,
    BASE_FONT_SIZE: 60,
    MAX_FONT_SIZE: 90,
    NS: "http://www.w3.org/2000/svg"
});